import React, { useState } from 'react';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import UiSwitch from '../../../_uiComponents/UiSwitch';
import { Grid } from "@mui/material";
import UiInput from '../../../_uiComponents/UiInput';
import UiMultipleSelectVoucher from '../../../_uiComponents/UiMultipleSelectVoucher';
import UiVoucherModal from '../../../_uiComponents/UiVoucherModal';
import UiTableBody from '../../../../_uiComponents/common/table/UiTableBody';
import UiTableHead from '../../../_uiComponents/UiTableHead';
import UiTableWrapper from '../../../../_uiComponents/common/table/UiTableWrapper';
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


export default function VoucherCategoryTable(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(3);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState();
    const [editModal, setEditModal] = React.useState(false);
    const handleCloseEdit = () => setEditModal(false);
    const handleEditShow = () => setEditModal(true);

    const actionFilter = (keyword) => {
        var list = data.filter(row => row.data.name.includes(keyword))
        console.log(list)
        setNodes(list)
    }

    //Sorting
    const handleRequestSort = (event, property) => {
        console.log(property)
        const isAsc = orderBy === property && order === "asc";
        console.log(isAsc)
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const headings = [
        { id: "name", name: "Name" },
        { id: "active", name: "Status" },
    ];

    const data = [
        {
            id: 1,
            name: "Voucher Category 1",
            enable: true,
            items: [
                {
                    id: 11,
                    name: "Voucher 1",
                    enable: true
                },
                {
                    id: 12,
                    name: "Voucher 2",
                    enable: true
                }
            ],
        },
        {
            id: 2,
            name: "Voucher Category 2",
            enable: false,
            items: [
                {
                    id: 21,
                    name: "Voucher 3",
                    enable: false
                },
                {
                    id: 22,
                    name: "Voucher 4",
                    enable: true
                }
            ],
        },

    ];

    //Empty rows issue set
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;
    console.log(emptyRows);


    //Data sorting
    const visibleRows = React.useMemo(
        () =>
            stableSort(data, getComparator(order, orderBy)).slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, data],
    );


    const [active, setActive] = React.useState();
    const [open, setOpen] = React.useState(false);
    const manageOpen = (clickedIndex) => {
        if (active === clickedIndex) {
            setActive(null);
            setOpen(true);
        } else {
            setActive(clickedIndex);
            setOpen(true);
        }
    };

    const [nodes, setNodes] = useState(data);

    return (
        <>
            <div className="sba-table-main-wr sba-permission-grid">
                <Grid item xs={12} lg={9} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={4} >
                            <UiInput type="search" label="Filter by name" onInput={(e) => actionFilter(e.target.value)} />
                        </Grid>

                        <Grid item xs={12} lg={4} >
                            <UiMultipleSelectVoucher
                                name="eee"
                                label="Filter by status"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <UiTableWrapper>
                    <UiTableHead
                        headings={headings}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                    />
                    <UiTableBody>
                        {visibleRows.map((row, index) => (
                            <>
                                <TableRow
                                    key={row.id}
                                    sx={{
                                        "&:last-child td, &:last-child th":
                                            { border: "none" },
                                    }}
                                >
                                    <TableCell align="left" >
                                        <span className='sba-voucher-table-name'
                                            onClick={() => {
                                                manageOpen(index);
                                            }}>
                                            {active == index && open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                            {row.name}
                                        </span>
                                    </TableCell>
                                    <TableCell align='center' >
                                        <UiSwitch type="button" size="large"></UiSwitch>
                                    </TableCell>
                                </TableRow>

                                {active === index && open && (
                                    <>
                                        {row.items.map((item) => (
                                            <TableRow>
                                                <TableCell className='sba-voucher-dropdown-content'
                                                    onClick={handleEditShow} align="left">{item.name}</TableCell>
                                                <TableCell className='sba-voucher-dropdown-switch' align="center">
                                                    <UiSwitch type="button" size="large"></UiSwitch>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </>
                                )}
                            </>
                        ))}
                    </UiTableBody>
                </UiTableWrapper>

                <UiVoucherModal
                    handleClose={handleCloseEdit}
                    open={editModal}
                    className="sba-voucher-main-wr"
                >

                    <div className="sba-voucher-image">
                        <img src="../../../../styles/images/png/abc.png" />
                    </div>

                    <Grid container spacing={2} mt={2}>
                        <Grid
                            item
                            xs={12} lg={12}
                        >
                            <h3>Adidas eGift</h3>
                            <p>adidas is the brand with the Three Stripes, the icon.
                                From the stadium to the streets. From the courts to the catwalk.</p>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            display: "flex",
                            mt: 2,
                        }}
                    >
                        <Grid
                            item
                            xs={12} lg={12}
                        >
                            <h2>About this product</h2>
                            <div className='sba-voucher-popup-headers'>
                                <h4>How to redeem</h4>
                            </div>
                            <p>Gift cards can be redeemed online and instoreGame on! Using your gift card is simple. In the Gift Card Field
                                of the payment screen, enter the full number located below the barcode and your 4 -digit PIN. Click Apply.</p>

                            <div className='sba-voucher-popup-headers'>
                                <h4>Terms and conditions</h4>
                            </div>
                            <p>Gift cards can be redeemed online and instoreGame on! Using your gift card is simple. In the Gift Card Field
                                of the payment screen, enter the full number located below the barcode and your 4 -digit PIN. Click Apply.</p>
                        </Grid>
                    </Grid>
                </UiVoucherModal>
            </div>
        </>
    );
}
